import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Stat } from "./stat";



@Injectable({
    providedIn: 'root',
})
export class StatsService {
    private statsSource = new Subject<Stat>();

    statsObserver = this.statsSource.asObservable();

    add(stats: Stat) {
        if (stats) {
            this.statsSource.next(stats);
        }
    }
}